export default __webpack_public_path__ + "static/media/6.56612f23.jpg";